import { win } from '../context'

/** Alineado con `desktop` en `_breakpoints.scss` (min-width: 1200px). */
const PARALLAX_DESKTOP_MIN = 1200

export default class BackgroundMedia {
    private wrapper: HTMLElement
    private el: HTMLElement
    private wrapperHeight = 0
    private offset = 0
    private hasParallax = false
    private parallaxTween: { kill: () => void } | null = null

    constructor(wrapper: HTMLElement, el: HTMLElement) {
        this.wrapper = wrapper
        this.el = el
    }

    init() {
        this.hasParallax = this.wrapper.classList.contains('has-parallax')

        if (this.hasParallax && win.w >= PARALLAX_DESKTOP_MIN) {
            this.setupParallax()
        }
    }

    private setupParallax() {
        this.measure()

        this.parallaxTween = gsap.fromTo(
            this.el,
            {
                height: () => {
                    this.measure()
                    return `${this.wrapperHeight + this.offset}px`
                },
                y: () => {
                    this.measure()
                    return `${-this.offset}px`
                },
            },
            {
                y: () => {
                    this.measure()
                    return `${this.offset / 2}px`
                },
                ease: 'linear',
                scrollTrigger: {
                    trigger: this.wrapper,
                    start: 'top bottom',
                    end: 'bottom top',
                    scrub: true,
                    invalidateOnRefresh: true,
                },
            }
        )
    }

    private teardownParallax() {
        if (this.parallaxTween) {
            this.parallaxTween.kill()
            this.parallaxTween = null
        }
        gsap.set(this.el, { clearProps: 'height,transform' })
    }

    private measure() {
        this.wrapperHeight = this.wrapper.offsetHeight
        this.offset = this.wrapperHeight / 5
    }

    refresh() {
        if (!this.hasParallax) return

        const isDesktop = win.w >= PARALLAX_DESKTOP_MIN
        if (isDesktop && !this.parallaxTween) {
            this.setupParallax()
        } else if (!isDesktop && this.parallaxTween) {
            this.teardownParallax()
        } else if (isDesktop && this.parallaxTween) {
            this.measure()
        }
    }

    cleanup() {
        this.teardownParallax()
    }
}
